import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { View, Text, StyleSheet } from "react-native-web";
import FileBase64 from "react-file-base64";
import { ActivityIndicator } from "react-native-web";
import { connect, useDispatch, useSelector } from 'react-redux'
import { Tabs } from "antd";
import { Select } from 'antd';
import { Alert } from 'antd';
import { _ } from 'underscore'
import { Modal, Button } from 'antd';
import Received from './Inbox/Received';
import Sent from './Inbox/Sent';
import Drafts from './Inbox/Drafts';
import Settings from '../../shared/config/Settings';
import MessageView from "../components/MessageView";

import { notification, Space } from 'antd';
// import FileBase64 from 'react-file-base64';
import getUserId from '../../shared/core/GetToken';
import { msgClenuplatData, sendNewMessagetoAPI } from '../../shared/actions/NewMessageActions';
import { clearSetItemMessage, setItemMessage } from '../../shared/actions/SetMessageItemAction';
// import GetAppSettings from '../../shared/core/GetAppSettings';
import renderHTML from "react-render-html";
import { checkToken } from '../../shared/actions/TokenValidActions';
import { fetchDraftsMessageFromApi } from '../../shared/actions/DraftsMessageAction';
import { useLocation } from 'react-router-dom';
import { appServices } from '../../shared/redux/actions/appServices';
import getUserInfo from '../../shared/core/GetTokenized';
import PortalAlerts from '../components/PortalAlerts';
// const useHistory = require("react-router-dom").useHistory;

const { TabPane } = Tabs;

const Med = (props) => {
    const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
    const history = useNavigate()
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
    const [activeKey, setActiveKey] = useState("1");
    const PatienInformation = JSON.parse(information);
    let fileInput = useRef(null);
    const location = useLocation();
const dispatch= useDispatch();
    const [isloaded, setIsload] = React.useState(false);
    const handleTabChange = (key) => {
        setActiveKey(key);
      };
    React.useEffect(() => {
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://indici-pre-production.web.app/assets/js/template.js";
        document.body.appendChild(script);
        // d.div.appendChild(script);
    }, []);
   
    const fromButton = location.state?.fromButton;
  
    // Now you can use the `fromButton` value to conditionally render or set state
    useEffect(() => {
      if (fromButton) {
        // Do something when the state is passed
        console.log('Navigated from the button with state:', fromButton);
        setNewMsgModal(true)
      }
    }, [fromButton]);


    //sending items
    const [centerName, setCenterName] = useState('');
    const [centerRef, setCenterRef] = useState('');
    const [centersArray, setCentersArray] = useState([]);
    const [providerArray, setProviderArray] = useState([]);
    const [resourceType, setResourceType] = useState('');
    const [recpName, setRecpName] = useState('');
    const [successMessage, setSuccessMessage] = useState('Your Message has been sent Successfully');


    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');


    const [fileSize, setFileSize] = useState('');
    const [fileType, setfileType] = useState('');
    const [fileBase, setFileBase] = useState('');
    const [newMsgModal, setNewMsgModal] = useState(false);
    const {MessagingRecipientsData , isMessagingRecipients}=useSelector((state)=>state.MessagingRecipients)
    // const { SendMessage, isSending, isSendMessageSuccess, error } = props.SendMessage
    const { SendMessage, isSending, isSendMessageSuccess, error } = useSelector((state)=>state.NewMessages)
    const { LocationData, isLocation } = useSelector((state)=>state.Location)
    const {GetMessageSubjectData, isGetMessageSubject} = useSelector((state)=>state.GetMessageSubject)
     useEffect(() => {
   if( MessagingRecipientsData){
    setProviderLoading(false);
    //console.log(json[0].entry)
    setProviderArray(MessagingRecipientsData);
   }
  }, [MessagingRecipientsData])

    const [portalSetting, setPortalSetting] = useState(null);
    // const { Item, screenName } = props.SetMessageItem;


    const [selected, setSelected] = useState()
    const [selectedCenter, setSelectedCenter] = useState()

    const [filesList, setFilesList] = useState([]);
   const locObject={
    TypeID:1,
    PatientID: Profile&& Profile[0].resource.id
   }
    const clearSelected = () => {
        // this line will clear the select
        // when you click on the button
        setSelected(null)
    }
    const openNotificationWithIcon = type => {
        notification[type]({
            //message: 'Message Sent',
            description:
                SendMessage,
        });
    };
    function getOptionsArray(data, optionText, optionVal) {
        const optionArray = [];
        data.map((option) => {
            optionArray.push({
                name: option[optionText],
                id: option[optionVal]
            })
        })
        return optionArray
    }
    React.useEffect(() => {
        if (isSendMessageSuccess) {
            console.log(SendMessage , "SendMessage")
            setNewMsgModal(false)
            // document.getElementById('userSubject').value = ''
            // document.getElementById('userMsg').value = ''
            clearSelected()
            setSelectedCenter(null)
            PortalAlerts("success" , "success" , SendMessage)
            // setCenterRef('');
            // setRecpName('');
            // setResourceType('');
            // setSubject(null)
            // setMessage(null)
            // openNotificationWithIcon('success')
            dispatch(appServices.gettingNewMessagesClear())
            // props.cleandata()
            // window.location.reload()
        }
        
    }, [isSendMessageSuccess])
    // const sendMessageSuccesfully = () => {
    //     // setNewMsgModal(false)
    //     // // document.getElementById('userSubject').value = ''
    //     // // document.getElementById('userMsg').value = ''
    //     // clearSelected()
    //     // setSelectedCenter(null)

    //     // props.cleandata()
    //     // props.getDraftsMessage(100, 1)
    //     window.location.reload();
    // }
    React.useEffect(() => {
        // props.tokenVal(history);
        // CallcenterList()
        if(Profile) dispatch(appServices.Location(locObject))
    }, [Profile])

    useEffect(() => {
        // GetAppSettings().then((info) => {
        //     const set = JSON.parse(info)
        //     setPortalSetting(set)
        // })
    }, [])
    function onChange(value) {
        setResourceType('')
        clearSelected();
        // alert(value)
        // setSelectedCenter()
        // alert(value)
        setCenterRef(value);
        const payload={
            PatientID: Profile[0].resource.id,
            PracticeLocationID : value
          }
          dispatch(appServices.MessagingRecipients(payload))
        // CallProviderList(value)
        // console.log("test", centersArray, { value })
        setSelectedCenter(centersArray.find(centers => centers.id == value).name)
        setCenterName(centersArray.find(centers => centers.id == value).name)

        // //console.log(centersArray[value]);
        // let id = centersArray[value].resource.extension[0].valueString;
        // // let resourceType = centersArray[value].resource.resourceType;

        // // setCenterName(centersArray[value].resource.name)
        // CallProviderList(id)
    }

    function onBlur() {
        //console.log('blur');
    }

    function onFocus() {
        //    CallcenterList()
        //console.log('focus');
    }

    useEffect(() => {
        if (providerArray && providerArray.length) {
            setSelected(providerArray[0].resource.name[0].text)
            setRecpName(providerArray[0].resource.name[0].text);
            setResourceType(providerArray[0].resource.resourceType + '/' + providerArray[0].resource.id);


        }

    }, [providerArray])
    function onChangeProvider(value) {
        setSelected(providerArray[value].resource.name[0].text)
        document.getElementById('errorProvider').innerHTML = ''
        setRecpName(providerArray[value].resource.name[0].text);
        setResourceType(providerArray[value].resource.resourceType + '/' + providerArray[value].resource.id);


        //console.log(providerArray[value].resource.resourceType + '/' + providerArray[value].resource.id);
        //console.log(providerArray[value].resource.name[0].text)
    }

    function onBlurProvider() {
        //console.log('blur');
    }

    function onFocusProvider() {
        //CallcenterList()
        //console.log('focus provider');
    }

    const [centerLoading, setCenterLoading] = useState(false)
    useEffect(() => {
        if(LocationData){
            let ob;
            let newarr = []
            // console.log("Center arrray",arr)
            LocationData.map((entry, item) => (
                ob = {
                    name: entry?.resource?.name,
                    id: entry?.resource?.identifier[0]?.value
                },
                newarr.push(ob)
            ))
            console.log("Center arrray", newarr)
            setCentersArray(newarr)
            // setMoveDayLookup(medicationsDays != undefined ? getOptionsArray(medicationsDays, 'DayName', 'TreatmentDaysID') : [])
            // setCentersArray(newarr)
            // getOptionsArray(newarr)

            // setCentersArray(json[0].entry)
            setCenterLoading(false)  
        }
    }, [LocationData])
    
    const CallcenterList = () => {

        setProviderArray([]);
        getUserId().then((userInfo) => {

            const item = JSON.parse(userInfo);
            var myHeaders = new Headers();
            setCenterLoading(true)
            myHeaders.append("Token", item.token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };
            const queryString = '?Token=' + item.token + '&PatientID=' + item.userid + '&TypeID=1';
            fetch(Settings.apiUrl + "Patient/Location" + queryString, requestOptions)

                .then(data => data.json())
                .then(json => {
                    // let arr = json[0].entry

                    let ob;
                    let newarr = []
                    // console.log("Center arrray",arr)
                    json[0].entry.map((entry, item) => (
                        ob = {
                            name: entry?.resource?.name,
                            id: entry?.resource?.identifier[0]?.value
                        },
                        newarr.push(ob)
                    ))
                    console.log("Center arrray", newarr)
                    setCentersArray(newarr)
                    // setMoveDayLookup(medicationsDays != undefined ? getOptionsArray(medicationsDays, 'DayName', 'TreatmentDaysID') : [])
                    // setCentersArray(newarr)
                    // getOptionsArray(newarr)

                    // setCentersArray(json[0].entry)
                    setCenterLoading(false)
                })
                .catch(err => {
                    //console.log(err)
                    setCenterLoading(false)
                })
        })
    }
    React.useEffect(() => {
        if (centersArray && centersArray.length && Profile) {
            const payload={
                PatientID: Profile[0].resource.id,
                PracticeLocationID : centersArray[0]?.id
              }
              dispatch(appServices.MessagingRecipients(payload))
            // CallProviderList(centersArray[0].id)
            setSelectedCenter(centersArray[0]?.name)
            //console.log(centersArray[value]);
            let id = centersArray[0]?.id;
            // let resourceType = centersArray[value].resource.resourceType;
            setCenterName(centersArray.find(centers => centers.id == id).name)
            setCenterRef(id);
        }

    }, [centersArray , Profile])

    const [providerLoading, setProviderLoading] = useState(false)
    useEffect(() => {
        if( MessagingRecipientsData){
         setProviderLoading(false);
         //console.log(json[0].entry)
         setProviderArray(MessagingRecipientsData);
        }
       }, [MessagingRecipientsData])
       
    const CallProviderList = (index) => {
        getUserId().then((userInfo) => {
            const item = JSON.parse(userInfo);
            var myHeaders = new Headers();
            setProviderLoading(true)
            myHeaders.append("Token", item.token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };
            // const queryString = "?Token=" + item.token + "&PatientID=" + item.userid + "&RoleID=" + centerRef index
            const queryString = "?Token=" + item.token + "&PatientID=" + item.userid + '&PracticeLocationID=' + index;
            //console.log(queryString)
            // const queryString = "cPatientID=" + item.userid + "&RoleID=" + index
            fetch(Settings.apiUrl + "Patient/MessagingRecipients" + queryString, requestOptions)
                .then(data => data.json())
                .then(json => {
                    setProviderLoading(false);
                    //console.log(json[0].entry)
                    setProviderArray(json[0].entry);
                })
                .catch(err => {
                    setProviderLoading(false)
                    //console.log(err)
                })
        })

    }

    const [filesData, setFilesData] = useState()
    const checkFile = (file) => {
        if (file) {
            for (var i = 0; i < file.length; i++) {
                setFileSize(file[i].size);
                setfileType(file[i].name.split('.').pop())
                setFileBase(file[i].base64)
                let ob = {
                    type: file[i].name.split('.').pop(),
                    size: file[i].size.split(' ')[0] * 1024,
                    base64: file[i].base64.split(',').pop(), //reader.result.split(',').pop(),
                };
                filesList.push(ob);
            }
            //console.log({ filesList })

        }



    }
    const [msgText, setMsgText] = useState('');
    const sendMessage = () => {


        if (centersArray.length === 0) {
            document.getElementById('error').innerHTML = 'Please select Center';
            alert("Please select Center");
            return
        }

        if (resourceType === '') {
            document.getElementById('errorProvider').innerHTML = 'Please select Provider';
            alert("Please select Provider");
            return
        }



        // let sub = document.getElementById('userSubject').value
        if (subject === '') {
            document.getElementById('errorSub').innerHTML = 'Please enter subject';
            alert("Please select subject");
            return
        }

        let msg = document.getElementById('userMsg').value
        if (msg === '') {
            document.getElementById('errorMsg').innerHTML = 'Please type your message';
            alert("Please select message");
            return
        }
        //console.log(sub, msg, centerName, centerRef, recpName, resourceType)
        // console.log("test", { centerName, centerRef, sub, msg, fileType, fileBase, filesList, resourceType, recpName })
        const  rawWith = {
            "resourceType": "Communication",
            "extension": [
                {
                    "url": "MessageBody",
                    "valueString": "" + msg + ""
                },
                {
                    "url": "MessageType",
                    "valueString": "Send Mail"
                },
                {
                    "url": "Centre",
                    "valueReference": {
                        "reference": "Location/" + centerRef + "",
                        "display": "" + centerName + ""
                    }
                }
            ],
            "status": "completed",
            "recipient": [
                {
                    "reference": "" + resourceType + "",
                    "display": "" + recpName + ""
                }
            ],
            "sender": {
                "reference": "Patient/" + Profile[0].resource.id,
                "display": "" + PatienInformation.username + ""
            },
            "payload": filesList?.map((item, index) => (
                {
                    "contentAttachment": {
                        "contentType": "" + item?.type + "",
                        "data": "" + item?.base64 + "",
                        "size": item?.size
                    }
                }
            )),
            "note": [
                {
                    "text": "" + subject + ""
                }
            ]
        }
        const rawwithout = {
            "resourceType": "Communication",
            "extension": [
                {
                    "url": "MessageBody",
                    "valueString": "" + msg + ""
                },
                {
                    "url": "MessageType",
                    "valueString":  "Send Mail"
                },
                {
                    "url": "Centre",
                    "valueReference": {
                        "reference": "Location/" + centerRef + "",
                        "display": "" + centerName + ""
                    }
                }
            ],
            "status": "completed",
            "recipient": [
                {
                    "reference": "" + resourceType + "",
                    "display": "" + recpName + ""
                }
            ],
            "sender": {
                "reference": "Patient/" + Profile[0].resource.id,
                "display": "" + PatienInformation.username + ""
            },
            "note": [
                {
                    "text": "" + subject + ""
                }
            ]
        }
        //console.log(sub, msg, centerName, centerRef, recpName, resourceType)
        dispatch(appServices.NewMessages(filesList ? rawWith : rawwithout))
        // props.sendData(null, centerName, centerRef, subject, msg, fileType, fileBase, filesList, resourceType, recpName, 'Send Mail', sendMessageSuccesfully)
        // document.getElementById('userSubject').value = null
        setSubject()
        document.getElementById('userMsg').value = null
        setFilesData(null)
        // fileInput.current.value=''
        // setfileType(null)
        setFileSize(null);
        setfileType(null)
        setFileBase(null)
    }
    const [subjectList, setSubjectList] = useState([])
    useEffect(() => {
     if(GetMessageSubjectData){
        setProviderLoading(false);
        //console.log(json[0].entry)
        let list = []
        GetMessageSubjectData.map((entry) => (
            list.push({ value: entry?.resource?.extension[0]?.valueString, name: entry?.resource?.extension[1]?.valueString })
        ))
        console.log("list", list)
        setSubjectList(list) //entry
     }
    }, [GetMessageSubjectData])
    
    // const [subject,setSubject] = useState('')
    const LoadMessageSubject = () => {
        // https://nhldevconnect.indici.ie/api/Patient/GetMessageSubject?Token=e5a4b191-6884-48f4-bc4c-b3682be33e9f
        getUserId().then((userInfo) => {
            const item = JSON.parse(userInfo);
            var myHeaders = new Headers();
            setProviderLoading(true)
            myHeaders.append("Token", item.token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };
            // const queryString = "?Token=" + item.token + "&PatientID=" + item.userid + "&RoleID=" + centerRef index
            const queryString = "?Token=" + item.token // "&PatientID=" + item.userid + '&PracticeLocationID=' + index;
            //console.log(queryString)
            // const queryString = "cPatientID=" + item.userid + "&RoleID=" + index
            fetch(Settings.apiUrl + "Patient/GetMessageSubject" + queryString, requestOptions)
                .then(data => data.json())
                .then(json => {
                    setProviderLoading(false);
                    //console.log(json[0].entry)
                    let list = []
                    json[0]?.entry.map((entry) => (
                        list.push({ value: entry?.resource?.extension[0]?.valueString, name: entry?.resource?.extension[1]?.valueString })
                    ))
                    console.log("list", list)
                    setSubjectList(list) //entry
                    // setProviderArray(json[0].entry);
                })
                .catch(err => {
                    setProviderLoading(false)
                    //console.log(err)
                })
        })

    }
    useEffect(() => {
        // LoadMessageSubject()
       if(Profile) dispatch(appServices.GetMessageSubject({PatientID:  Profile[0].resource.id }))

    }, [Profile])
    const saveDraft = () => {
        if (centersArray.length === 0) {
            document.getElementById('error').innerHTML = 'Please select Center';
            return
        }

        if (resourceType === '') {
            document.getElementById('errorProvider').innerHTML = 'Please select Provider';
            return
        }



        // let sub = document.getElementById('userSubject').value
        if (subject === '') {
            document.getElementById('errorSub').innerHTML = 'Please enter subject';
            return
        }

        let msg = document.getElementById('userMsg').value
        if (msg === '') {
            document.getElementById('errorMsg').innerHTML = 'Please type your message';
            return
        }
        const  rawWith = {
            "resourceType": "Communication",
            "extension": [
                {
                    "url": "MessageBody",
                    "valueString": "" + msg + ""
                },
                {
                    "url": "MessageType",
                    "valueString": "Drafts"
                },
                {
                    "url": "Centre",
                    "valueReference": {
                        "reference": "Location/" + centerRef + "",
                        "display": "" + centerName + ""
                    }
                }
            ],
            "status": "completed",
            "recipient": [
                {
                    "reference": "" + resourceType + "",
                    "display": "" + recpName + ""
                }
            ],
            "sender": {
                "reference": "Patient/" + Profile[0].resource.id,
                "display": "" + PatienInformation.username + ""
            },
            "payload": filesList?.map((item, index) => (
                {
                    "contentAttachment": {
                        "contentType": "" + item?.type + "",
                        "data": "" + item?.base64 + "",
                        "size": item?.size
                    }
                }
            )),
            "note": [
                {
                    "text": "" + subject + ""
                }
            ]
        }
        const rawwithout = {
            "resourceType": "Communication",
            "extension": [
                {
                    "url": "MessageBody",
                    "valueString": "" + msg + ""
                },
                {
                    "url": "MessageType",
                    "valueString":  "Drafts" 
                },
                {
                    "url": "Centre",
                    "valueReference": {
                        "reference": "Location/" + centerRef + "",
                        "display": "" + centerName + ""
                    }
                }
            ],
            "status": "completed",
            "recipient": [
                {
                    "reference": "" + resourceType + "",
                    "display": "" + recpName + ""
                }
            ],
            "sender": {
                "reference": "Patient/" + Profile[0].resource.id,
                "display": "" + PatienInformation.username + ""
            },
            "note": [
                {
                    "text": "" + subject + ""
                }
            ]
        }
        //console.log(sub, msg, centerName, centerRef, recpName, resourceType)
        dispatch(appServices.NewMessages(filesList ? rawWith : rawwithout))
        // props.sendData(null, centerName, centerRef, subject, msg, fileType, fileBase, filesList, resourceType, recpName, 'Drafts', sendMessageSuccesfully)
        // document.getElementById('userSubject').value = null
        setSubject('')
        document.getElementById('userMsg').value = null
    }
    ///
    return (
        <div>
            {/* <Header />

            <div id="myphonemenu" className="page-body">
                <Sidebar /> */}
                <div className="page-content-wrapper">
                    <div className="page-content-wrapper-inner">
                        <div className="viewport-header">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb has-arrow">
                                    <li className="breadcrumb-item">
                                        {/* <a href=>Dashboard</a> */}
                                        <Link to="/">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Messages
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="content-viewport">
                            <button
                                onClick={() => setNewMsgModal(true)}
                                style={{ marginBottom: 20, marginLeft: 5 }}
                                className="btn btn-primary has-icon ">
                                {/* email-composer */}
                                <i className="mdi mdi-plus" />Compose </button>
                            {/* <div className="row mb-2">
                                <div className="col-md-12 mx-auto">
                                    <div className="alert alert-warning" role="alert">

                                        <h6 className="alert-heading">Disclaimer:</h6>
                                        {portalSetting &&
                                            portalSetting.PortalMessageTermsandConditions &&
                                            renderHTML(portalSetting.PortalMessageTermsandConditions)

                                        }

                                    </div>
                                </div>
                            </div> */}
                            {portalSetting && portalSetting.send ?
                                <div className="email-header">
                                    <button className="btn email-aside-list-toggler">
                                        <i className="mdi mdi-menu" />
                                    </button>


                                    <button onClick={() => setNewMsgModal(true)}
                                        className="btn btn-primary has-icon ">
                                        {/* email-composer */}
                                        <i className="mdi mdi-plus" />Compose </button>
                                </div> : null
                            }

                            {/* {
                                isSendMessageSuccess && <Alert
                                    message="Success"
                                    description="Message has been sent Succesfuly"
                                    type="success"
                                    showIcon
                                />

                            }
                            {
                                isSendMessageSuccess && window.location.reload()
                            } */}

                            <div className="email-wrapper grid">
                                <div className="email-aside-list">
                                    <Tabs 
                                    defaultActiveKey="1"
                                    onChange={handleTabChange}
                                    activeKey={activeKey}
                                      centered >
                                        <TabPane 
                                         tab="Inbox" key="1" >
                                            <Received activeKey={activeKey} />
                                        </TabPane>

                                        <TabPane  tab="Sent" key="2">
                                            <Sent activeKey={activeKey} />
                                        </TabPane>

                                        <TabPane   tab="Draft" key="3">
                                            <Drafts activeKey={activeKey}/>
                                        </TabPane>

                                    </Tabs>
                                </div>
                            </div>
                        </div>
                    </div>

                    <footer className="footer"></footer>
                </div>
            {/* </div> */}

            <Modal
                title="New Message"
                centered
                open={newMsgModal}
                closable={false}
                // onOk={() => {
                //     setNewMsgModal(false);

                // }}loading={loading}
                // onCancel={() => setNewMsgModal(false)}
                style={{ top: 10, bottom: 90, overflow: "hidden" }}
                width={1000}
                // key={new Date().to()}
                footer={[
                    isSending ?
                        <ActivityIndicator size="small" color="#00A1DE" />

                        :
                        <>
                            <Button key="back" onClick={() => {
                                //document.getElementById('userSubject').value = null
                                //document.getElementById('userMsg').value = null
                                // alert(JSON.stringify(fileInput))
                                // console.log(fileInput)
                                setNewMsgModal(false)
                                window.location.reload()
                            }}>
                                Cancel
                            </Button>
                            <Button key="submit" type="secondary" onClick={() => saveDraft()
                            }>
                                Draft
                            </Button>
                            <Button key="submit" type="primary" onClick={() => { sendMessage() }}>
                                Send
                            </Button>
                        </>


                ]}
            >
                <div className="row" >
                    <div className="col-md-12 mx-auto">
                        <div className="col-md-12 mx-auto">
                            <div className="alert alert-warning" role="alert">

                                {/* <h6 className="alert-heading">Disclaimerhgjhgjgjh:</h6> */}
                                {
                                     Profile  && Profile.length ? (
                                        // <p>{Profile[0].resource.extension[9].hasOwnProperty('valueString') ? Profile[0].resource.extension[9].valueString :"N/A" }</p>
                                        Profile[0].resource.extension.map((item, index) => {

                                            return (
                                                item.url == "MessageDisclaimer" &&
                                                <div className="row mb-2">
                                                    {/* {isFetching && <ActivityIndicator color='blue' size='small' />} */}
                                                    <div className="col-md-8 mx-auto">
                                                        <div className="alert alert-warning" role="alert">
                                                            <h6 className="alert-heading">Disclaimer:</h6>

                                                            <p>{item.valueString ? item.valueString : "N/A"}</p>
                                                        </div>
                                                    </div>
                                                </div>


                                            )
                                        })
                                    ) : null
                                }
                                {/* {portalSetting &&
                                    portalSetting.PortalMessageTermsandConditions &&
                                    renderHTML(portalSetting.PortalMessageTermsandConditions)

                                } */}

                            </div>
                        </div>

                        <div style={{}} className="form-group row mb-0">
                            <div className="col-md-6">
                                <label className="label" style={{ width: 68 }}>To</label>
                                {isLocation && <ActivityIndicator size="small" color="#00A1DE" />}
                                {centersArray && centersArray.length ?
                                    <Select
                                        defaultValue={centersArray[0]?.id}
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="Select a person"
                                        optionFilterProp="children"
                                        onChange={onChange}
                                        onFocus={onFocus}
                                        onBlur={onBlur}
                                        value={selectedCenter}
                                    >
                                        {
                                            centersArray.map((item, index) => <Select.Option value={item.id} key={item.id}>{item.name}</Select.Option>)
                                        }

                                    </Select>
                                    : !isLocation &&
                                    <p>No registered Role Available.</p>
                                }

                                <p id="error" style={{ color: 'red' }}></p>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group input-recipient" style={{ paddingBottom: 4 }}>
                                    <label className="label" style={{}}>Select Provider</label>
                                    <div className="showcase_content_area">
                                        {providerLoading ? <ActivityIndicator size="small" color="#00A1DE" />
                                            :
                                            providerArray && providerArray.length ?
                                                <Select
                                                    showSearch
                                                    defaultValue={providerArray[0].resource.name[0].text}
                                                    style={{ width: '100%' }}
                                                    placeholder="Select Provider"
                                                    optionFilterProp="children"
                                                    onChange={onChangeProvider}
                                                    onFocus={onFocusProvider}
                                                    onBlur={onBlurProvider}
                                                    value={selected}
                                                >
                                                    {providerArray !== undefined && providerArray.map((item, index) => <Select.Option key={index}>{item.resource.name[0].text}</Select.Option>)}

                                                </Select>
                                                : !providerLoading && <p>No registered provider available.</p>

                                        }
                                        <p id="errorProvider" style={{ color: 'red' }}></p>

                                    </div>
                                </div>


                            </div>

                        </div>


                        <div style={{}} className="form-group row mb-0">

                            <div className="form-group col-md-12">
                                <label className="label" style={{ width: 68 }}>Subject</label>
                                {/* <input type="text" className="form-control "
                                    placeholder="Subject" id="userSubject" //
                                    onClick={() => document.getElementById('errorSub').innerHTML = ''} /> */}
                                {/* subjectList.length ? <ActivityIndicator size="small" color="#00A1DE" />
                                    : */}
                                {
                                    subjectList && subjectList.length ?
                                        <Select
                                            showSearch
                                            defaultValue={subjectList[0].name}
                                            style={{ width: '100%' }}
                                            placeholder="Select Subject"
                                            optionFilterProp="children"
                                            onChange={(res) => {
                                                setSubject(res)
                                            }}
                                            // onFocus={onFocusProvider}
                                            // onBlur={onBlurProvider}
                                            value={subject}
                                        >
                                            {subjectList !== undefined && subjectList.map((item, index) => <Select.Option key={index} value={item?.name}>{item.name}</Select.Option>)}

                                        </Select>
                                        : !providerLoading && <p>No registered provider available.</p>

                                }

                                <p id="errorSub" style={{ color: 'red' }}></p>
                            </div>
                        </div>
                        <div style={{}} className="form-group row mb-0">
                            <div className="form-group col-md-12">

                                <textarea id="userMsg" className="form-control" rows={8} placeholder="Write your message here" defaultValue={""} onClick={() => document.getElementById('errorMsg').innerHTML = ''} />
                                <p id="errorMsg" style={{ color: 'red' }}></p>
                            </div>


                        </div>

                        <FileBase64
                            className="action-buttons"
                            multiple={true}
                            id="filesValue"
                            ref={fileInput}
                            value={filesData}
                            // key={new Date().toLocaleTimeString()}
                            // ref={useRef()}
                            // key={new Date.now().toString()}
                            //ref={refParam => fileInput = refParam}
                            onClick={(e) => e.target.value = null}
                            onDone={(files) => {

                                // setFilesData(files)
                                checkFile(files)
                                // e.target.value=null
                                fileInput.current = null
                            }} />
                        <div style={{ alignItems: 'flex-end', backgroundColor: 'red' }} className="form-group row mb-0">

                        </div>

                    </div>


                </div>

            </Modal>
            <Modal
                title="New Message"
                centered
                // visible={newMsgModal}
                closable={false}
                // onOk={() => {
                //     setNewMsgModal(false);

                // }}loading={loading}
                // onCancel={() => setNewMsgModal(false)}
                style={{ top: 10, bottom: 90, overflow: "hidden" }}
                width={1000}
                footer={[
                    isSending ?
                        <ActivityIndicator size="small" color="#00A1DE" />

                        :
                        <>
                            <Button key="back" onClick={() => setNewMsgModal(false)}>
                                Cancel
                            </Button>
                            <Button key="submit" type="secondary" onClick={() => saveDraft()}>
                                Draft
                            </Button>
                            <Button key="submit" type="primary" onClick={() => sendMessage()}>
                                Send
                            </Button>
                        </>


                ]}
            >
                <div className="row" >
                    <div className="col-md-12 mx-auto">
                        <div className="col-md-12 mx-auto">
                            <div className="alert alert-warning" role="alert">

                                <h6 className="alert-heading">Disclaimer:</h6>
                                {portalSetting &&
                                    portalSetting.PortalMessageTermsandConditions &&
                                    renderHTML(portalSetting.PortalMessageTermsandConditions)

                                }

                            </div>
                        </div>

                        <div style={{}} className="form-group row mb-0">
                            <div className="col-md-6">
                                {/* <div className="form-group input-recipient"> showcase_content_area */}
                                <label className="label" style={{ width: 68 }}>To</label>
                                {/* <div className="col-md-6 "> */}
                                {isLocation && <ActivityIndicator size="small" color="#00A1DE" />}
                                {centersArray && centersArray.length ?
                                    <Select
                                        defaultValue={centersArray[0]?.id}
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="Select a person"
                                        optionFilterProp="children"
                                        onChange={onChange}
                                        onFocus={onFocus}
                                        onBlur={onBlur}
                                        value={selectedCenter}

                                    >
                                        {
                                            centersArray.map((item, index) => <Select.Option key={index}>{item?.name}</Select.Option>)
                                        }

                                    </Select>
                                    : !centerLoading &&
                                    <p>No registered Role Available.</p>
                                }

                                <p id="error" style={{ color: 'red' }}></p>
                                {/* </div> */}
                                {/* </div> */}
                            </div>
                            <div className="col-md-6">
                                <div className="form-group input-recipient" style={{ paddingBottom: 4 }}>
                                    <label className="label" style={{}}>Select Provider</label>
                                    <div className="showcase_content_area">

                                        {providerLoading ? <ActivityIndicator size="small" color="#00A1DE" />
                                            :
                                            providerArray && providerArray.length ?
                                                <Select
                                                    showSearch
                                                    defaultValue={providerArray[0].resource.name[0].text}
                                                    style={{ width: '100%' }}
                                                    placeholder="Select Provider"
                                                    optionFilterProp="children"
                                                    onChange={onChangeProvider}
                                                    onFocus={onFocusProvider}
                                                    onBlur={onBlurProvider}
                                                    value={selected}


                                                >
                                                    {providerArray !== undefined && providerArray.map((item, index) => <Select.Option key={index}>{item.resource.name[0].text}</Select.Option>)}

                                                </Select>
                                                : !providerLoading && <p>No registered provider available.</p>

                                        }
                                        <p id="errorProvider" style={{ color: 'red' }}></p>

                                    </div>
                                </div>


                            </div>

                        </div>


                        <div style={{}} className="form-group row mb-0">

                            <div className="form-group col-md-12">
                                <label className="label" style={{ width: 68 }}>Subject</label>
                                <input type="text" className="form-control "
                                    placeholder="Subject" id="userSubject" //
                                    onClick={() => document.getElementById('errorSub').innerHTML = ''} />
                                <p id="errorSub" style={{ color: 'red' }}></p>
                            </div>
                        </div>
                        <div style={{}} className="form-group row mb-0">
                            <div className="form-group col-md-12">

                                <textarea id="userMsg" className="form-control" rows={8} placeholder="Write your message here" defaultValue={""} onClick={() => document.getElementById('errorMsg').innerHTML = ''} />
                                <p id="errorMsg" style={{ color: 'red' }}></p>
                            </div>


                        </div>
                        {/* <FileBase64
                            className="action-buttons"
                            multiple={true}
                            onDone={(files) => checkFile(files)} /> */}
                        <div style={{ alignItems: 'flex-end', backgroundColor: 'red' }} className="form-group row mb-0">

                        </div>

                    </div>


                </div>

            </Modal>


        </div>

    );
};

const styles = StyleSheet.create({
    textDetails: {
        textAlign: "justify",
        color: "#95989A",
        fontSize: 15,
    },
    textDetailsInner: {
        textAlign: "justify",
        color: "#333333",
        fontSize: 14,
    },
});
// function mapStateToProps(state) {
//     return {

//         SetMessageItem: state.SetMessageItem,
//         SendMessage: state.SendMessage,
//         Profile: state.Profile,
//     }
// }

// function mapDispatchToProps(dispatch) {
//     return {
//         // sendData: (draftMessageId, centerName, centerReference, subject, emailText, fileType, fileBase, fileSize, resourceType, msgRecp, msgType, sendMessageSuccesfully) => dispatch(sendNewMessagetoAPI(draftMessageId, centerName, centerReference, subject, emailText, fileType, fileBase, fileSize, resourceType, msgRecp, msgType, sendMessageSuccesfully)),
//         // setMessageItem: (item, screenName) => dispatch(setItemMessage(item, screenName)),
//         // getDraftsMessage: (pageSize, pageNumber) => dispatch(fetchDraftsMessageFromApi(pageSize, pageNumber)),

//         cleandata: () => dispatch(msgClenuplatData()),
//         // tokenVal: (history) => dispatch(checkToken(history))
//     }
// }


// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(Med);
export default Med
